import { Component, inject, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-create-mode-toggle',
  template: `
    @if (canEdit()) {
      <mat-slide-toggle color="primary" class="mode-toggle" [checked]="createMode()" (change)="toggleCreateMode()">
        {{ 'Global.CreateMode' | translate }}
      </mat-slide-toggle>
    }
  `,
  standalone: true,
  imports: [MatSlideToggleModule, FormsModule, TranslateModule],
})
export class CreateModeToggleComponent {
  private appService = inject(AppService);
  private authService = inject(AuthService);

  public createMode = toSignal(this.appService.createMode$, { initialValue: false });
  public readonly canEdit: WritableSignal<boolean> = signal(this.authService.isWriter());

  toggleCreateMode(): void {
    this.appService.setCreateMode(!this.createMode());
  }
}
